<!--
    Represents a link that looks like a button. The advantage of
    using this over a pc-button is that because the underlying HTML
    element is a true <a> link, the user gets the right-click context
    actions like opening in a new tab. The limitation is that no additional
    processing can happen between the click and following the href.

    We should avoid adding these in new places where a link is more
    appropriate, but they can be used in place of existing buttons to add
    the right-click functionality while preserving the appearance of a button.
-->
<template>
    <a
        v-bind:class="classObj"
        class="btn">
        <slot />
    </a>
</template>
<script>
    export default {
        props: {
            primary: { type: Boolean, required: false, default: false },
            warning: { type: Boolean, required: false, default: false },
            success: { type: Boolean, required: false, default: false },
            small: { type: Boolean, required: false, default: false },
            outline: { type: Boolean, required: false, default: false }
        },
        computed: {
            classObj() {
                return {
                    "btn-primary": this.primary,
                    "btn-warning": this.warning,
                    "btn-success": this.success,
                    "btn-secondary": !this.primary && !this.warning && !this.success && !this.outline,
                    "btn-sm": this.small,
                    "pc-btn-min-width-8spacer": true
                };
            }
        }
    };
</script>
